export enum TabsSummary {
  delivered = 0,
  inDistribution = 1,
  dispatched = 2
}

export enum Notifications {
  returnToOrigin = 1,
  impossibleDelivery = 2,
  reportedIncident = 3,
  pendingPayment = 4,
  resume = 5
}

export interface Resume {
  date: string,
  countDispatched: number,
  countDistribution: number,
  countDelivered: number
}

export interface NotificationResponse {
  notifications: NotificationItem[];
  unreadCount: number;
  totalCount: number;
  page: number;
  pageSize: number;
  hasNextPage: boolean;
}

export interface NotificationItem {
  id: number,
  typeNotification: number,
  metadata: NotificationDiferentStatus | NotificationDeleteShipments | NotificationResume,
  isRead: boolean,
  readAt: string | null
}

export interface NotificationDeleteShipments {
  shipmentQuoteId: number,
  unpaidQuotesHours: number,
  deleteQuotesHours: number,
  createdAt: string
}

export interface NotificationDiferentStatus {
  isReturn: boolean,
  ocasaStatus: string,
  ocasaStatusId: number,
  shipmentId: number,
  trackingCode: string
}

export interface NotificationResume {
  Completed: {
    Count: number,
    Shipments: ShipmentsResume[]
  },
  Dispatched: {
    Count: number,
    Shipments: ShipmentsResume[]
  },
  InDistribution: {
    Count: number,
    Shipments: ShipmentsResume[]
  },
  TotalReturns: number,
  TotalShipments: number,
  UserId: number
}

export interface ShipmentsResume {
  CreationTimestamp: string,
  DestinationAddress: string,
  DestinationContact: string,
  DestinationName: string,
  Id: number,
  IsReturn: boolean,
  OcasaStatus: string,
  StatusTimestamp: string,
  TrackingCode: string
}